import { ReactNode } from 'react';

import { RowSelection } from '~/shared/hooks/useRowSelection';

import { RowSelectCheckbox } from './RowSelectCheckbox';

interface BulkSelectableCellProps {
    selection?: RowSelection;
    isSelectable?: boolean;
    rowId: string;
    children: ReactNode;
}

export function BulkSelectableCell({
    selection,
    isSelectable,
    rowId,
    children,
}: BulkSelectableCellProps) {
    if (!selection?.isSelectMode) {
        return <>{children}</>;
    }

    if (!isSelectable) {
        return null;
    }

    return (
        <RowSelectCheckbox
            checked={selection.isSelected(rowId)}
            onCheckedChange={() => selection.toggleRow(rowId)}
            data-testid="row-select-checkbox"
        />
    );
}
